import React, { FC } from 'react';
import styled from 'styled-components';
import { Label, AnalyticsComponent, AnalyticsProps } from '@inplayer-org/inplayer-ui';

const StyledLink = styled.a<AnalyticsProps>`
  text-decoration: underline;
`;

interface Props {
  tag: string;
  children: string;
  disabled?: boolean;
  onClick?: (...args: any) => void;
}

const TaggedLink: FC<Props> = ({ tag, children, disabled, onClick }) => {
  if (disabled) {
    return (
      <Label disabled>
        <u>{children}</u>
      </Label>
    );
  }

  return (
    <AnalyticsComponent>
      {({ pages, tracker, merchantId, ip }) => (
        <StyledLink
          tag="link_create_new_channel"
          onClick={(e: any) => {
            if (onClick) {
              onClick(e);
            }

            if (tag) {
              tracker.track({
                event: 'click',
                type: 'link',
                tag,
                pages,
                merchantId,
                ip,
              });
            }
          }}
        >
          {children}
        </StyledLink>
      )}
    </AnalyticsComponent>
  );
};

export default TaggedLink;
